module.exports = __webpack_public_path__ + "img/roma.856ba878.jpg";